import FeatureType from "./FeatureCollection/Feature/FeatureType";

export default class CoordinatesAssembler {
    toCoordinatesLatLng(features) {
        const coords = [];
        features.forEach(feature => {
            const {geometry: {coordinates, type}} = feature;
            if (type === FeatureType.POINT) {
                coords.push({lat: coordinates[1], lng: coordinates[0]})
            } else if (type === FeatureType.POLYGON) {
                coordinates[0].forEach(coordinate => {
                    coords.push({lat: coordinate[1], lng: coordinate[0]});
                });
            }
        });
        return coords;
    }
}